export default [
  {
    value: "regular",
    title: "This is a Regular attribute",
    copy: "This is a regular value",
  },
  {
    value: "date",
    title: "This is a Date field",
    copy: "This is a value that indicates a date",
  },
  {
    value: "metric",
    title: "This is a Metric field",
    copy: "This is a value that can be used as a filter",
  },
  {
    value: "unique",
    title: "This is a unique ID",
    copy: "This is an identifier that can be used across different data sets",
  },
];

export const doMerge = (
  blocks,
  visualizationId,
  data,
  cacheKey,
  meta,
  error
) => {
  const con = blocks.find((b) =>
    b.charts.find((q) => q.visualizationId === visualizationId)
  );

  if (!con) {
    return;
  }

  return {
    data,
    loading: false,
    refreshing: false,
    loaded: true,
    meta,
    cacheKey,
    error,
  };
};

// Use for Sales Funnel Category Chart only
export const sortByLabel = (arr, key, forward = true) => {
  return arr.sort((a, b) => {
    const yearA = +a[key].substring(3, 7);
    const yearB = +b[key].substring(3, 7);
    const quarterA = +a[key].substring(1, 2);
    const quarterB = +b[key].substring(1, 2);
    if (yearA < yearB) return forward ? 1 : -1;
    if (yearA > yearB) return forward ? -1 : 1;
    if (quarterA < quarterB) return forward ? 1 : -1;
    if (quarterA > quarterB) return forward ? -1 : 1;
    return 0;
  });
};
